/*
 * File for ROUTES
 */

export const HOME = "/";
export const ONLINE_ACCESS = HOME + "online-access";
export const ONLINE_ACCESS_EMAIL_VERIFICATION = HOME + "email-verification-online-access";
export const REGISTRATION = HOME + "registration";
export const TRIAL_REGISTRATION = HOME + "trial-registration";
export const BECOME_MEMBER = "/become-member";
export const EMAIL_VERIFICATION = "/email-verification";
export const ADMIN = "/admin";
export const ADMIN_LOGIN = ADMIN + HOME;
export const RESORTS = "/s";
export const VERSIONS = "/versions";
export const IMPRINT = "/imprint";
export const PRIVACY_POLICY = "/privacy-policy";
export const GENERAL_TERMS_OF_USE = "/general-terms-of-use";
export const OFFER = "/offer";
export const MARKET_PLACE = "/marketplace";
export const MANAGE = "/manage";
export const BANK_DETAILS = "/bank-details";
export const MARKET_PLACE_SHARES = "/shares";
export const MARKET_PLACE_SELLING = "/selling";
export const MARKET_PLACE_BUY = MARKET_PLACE + MARKET_PLACE_SHARES;
export const MARKET_PLACE_MY_REQUESTS = MARKET_PLACE + MARKET_PLACE_SHARES + "/my-requests";
export const MARKET_PLACE_SELL = MARKET_PLACE + MARKET_PLACE_SHARES + MARKET_PLACE_SELLING;
export const MARKET_PLACE_BUY_OFFER = MARKET_PLACE + MARKET_PLACE_SHARES + OFFER;
export const MARKET_PLACE_SELL_OFFER = MARKET_PLACE + MARKET_PLACE_SHARES + MARKET_PLACE_SELLING + OFFER;
export const MARKET_PLACE_CREATE_OFFER = MARKET_PLACE_SELL + "/create-offer";
export const MARKET_PLACE_ADMIN = MARKET_PLACE + MARKET_PLACE_SHARES + MANAGE;
export const MARKET_PLACE_ADMIN_OFFER = MARKET_PLACE + MARKET_PLACE_SHARES + MANAGE + OFFER;
export const POINTS_SHARES = "/points-shares";
export const POINTS_SHARES_POINTS = POINTS_SHARES + "/points";
export const POINTS_SHARES_SHARES = POINTS_SHARES + MARKET_PLACE_SHARES;
export const POINTS_SHARES_POINTS_SELL = POINTS_SHARES_POINTS + "/sell";
export const POINTS_SHARES_BANK_DETAILS = POINTS_SHARES_POINTS_SELL + BANK_DETAILS;
export const POINTS_SHARES_POINTS_SELL_CREATE = POINTS_SHARES_POINTS_SELL + "/create";
export const POINTS_SHARES_POINTS_SELL_SUCCESS = POINTS_SHARES_POINTS_SELL + "/success";
export const POINTS_SHARES_POINTS_BUY = POINTS_SHARES_POINTS + "/buy";
export const POINTS_SHARES_POINTS_BUY_OFFER = POINTS_SHARES_POINTS_BUY + "/offer";
export const POINTS_SHARES_POINTS_BUY_SUCCESS = POINTS_SHARES_POINTS_BUY + "/success";
export const POINTS_SHARES_POINTS_TRANSFER = POINTS_SHARES_POINTS + "/transfer";
export const POINTS_SHARES_POINTS_TRANSFER_CREATE = POINTS_SHARES_POINTS_TRANSFER + "/create";
export const POINTS_SHARES_POINTS_TRANSFER_SUCCESS = POINTS_SHARES_POINTS_TRANSFER + "/success";

export const BOOKING = "/booking";
export const BOOKING_CONFIRMATION = "/booking-confirmation";
export const BOOKING_REPLACE = "/replace-booking";
export const BOOKING_REPLACE_CONFIRMATION = "/confirm-replace-booking";
export const BOOKING_UNCONFIRMED = "/booking-unconfirmed";
export const BOOKING_SERVICES = "/services";
export const RESERVATIONS = "/reservations";
export const UPCOMING = "/upcoming";
export const PAST = "/past";
export const CANCELLED = "/cancelled";
export const WAITING_LIST = "/waiting-list";
export const RESERVATIONS_UPCOMING = RESERVATIONS + UPCOMING;
export const RESERVATIONS_PAST = RESERVATIONS + PAST;
export const RESERVATIONS_CANCELLED = RESERVATIONS + CANCELLED;
export const RESERVATIONS_WAITING_LIST = RESERVATIONS + WAITING_LIST;
export const RESERVATIONS_WAITING_LIST_EDIT = RESERVATIONS_WAITING_LIST + "/edit";
export const RESERVATION_DETAILS = "/reservation-details";
export const RESERVATION_CANCEL = "/reservation-cancel";
export const RESERVATIONS_MANAGE = RESERVATIONS + "/manage";
export const PAYMENTS_DOCUMENTS = "/invoicing-documents";
export const USER_DOCUMENTS = PAYMENTS_DOCUMENTS + "/documents";
export const INVOICES_CREDITS = PAYMENTS_DOCUMENTS + "/invoicing";
export const INVOICES_CREDITS_DIRECT_DEBIT = INVOICES_CREDITS + "/direct-debit";
export const INVOICES_CREDITS_DIRECT_DEBIT_BANK_DETAILS = INVOICES_CREDITS_DIRECT_DEBIT + BANK_DETAILS;
export const INVOICE_PAYMENT_SUCCESS = INVOICES_CREDITS + "/payment-successful";
export const INVOICE_PAYMENT_FAIL = INVOICES_CREDITS + "/payment-failed";

export const PROFILE = "/profile";
export const PROFILE_ACCOUNT_SETTINGS = PROFILE + "/account";
export const PROFILE_ACCOUNT_SETTINGS_PERSONAL_DETAILS = PROFILE_ACCOUNT_SETTINGS + "/personal-details";
export const PROFILE_ACCOUNT_SETTINGS_CHANGE_PASSWORD = PROFILE_ACCOUNT_SETTINGS + "/change-password";
export const PROFILE_ACCOUNT_SETTINGS_PRIVACY_AND_NOTIFICATIONS = PROFILE_ACCOUNT_SETTINGS + "/privacy-and-notifications";
export const PROFILE_ACCOUNT_SETTINGS_MY_BANK_ACCOUNTS = PROFILE_ACCOUNT_SETTINGS + "/my-bank-accounts";
export const PROFILE_ACCOUNT_SETTINGS_ADD_BANK_ACCOUNT = PROFILE_ACCOUNT_SETTINGS_MY_BANK_ACCOUNTS + "/add-bank-account";

export const RESORTS_BOOKING_INFORMATION = "/resorts-booking-information";
export const POINTS_FREE_WEEKS = "/points-free-weeks";

export const AVAILABILITY_OVERVIEW = "/availability-overview";

export const ERROR_PAGE_404 = HOME + "404";
export const ERROR_PAGE_504 = HOME + "504";
export const ERROR_PAGE_500 = HOME + "500";
export const UNDER_CONSTRUCTION = HOME + "in-work";
export const MAINTENANCE = HOME + "maintenance";

export const BUTTONS = "/buttons";
export const INTL = "/intl";

export const ARTICLES = "/articles";

// TODO: This requires functionality to handle different locales, as this is a contentful page.
// Compose Pages
export const CONTACT = "/contact";
export const MEMBERSHIP = "/membership";
export const PARTNERSHIPS = "/partnerships";
export const TRY_OUT_HAPIMAG = "/try-out-hapimag";
export const CONCEPT = "/concept";
export const HOLIDAYS_AND_SHARES = "/members/holidays-and-shares";

export const DIRECT_SALES_ORDER = "/direct-sales/order";
export const DIRECT_SALES_ORDER_SUCCESS = DIRECT_SALES_ORDER + "/success";
export const BUY_SHARES_CONTRACT = "/buy-shares-contract";
